export default {
  featuredExperiences: 'Esperienze in primo piano',
  searchAllExperiences: 'Cerca tutte le esperienze',
  searchAll: 'Cerca tutto',
  groupSize: 'Grandezza del gruppo',
  eventSize: "Grandezza dell'evento",
  upTo: 'Fino a',
  whatWeDo: 'Cosa si farà',
  hostedBy: 'Ospitato da',
  whatsIncluded: 'Cosa è incluso',
  avail: 'Disponibilità',
  whereWeAre: 'Dove sarà',
  experienceCalendar: 'Calendario esperienze',
  experienceCancelled: 'Esperienza annullata',
  experienceStartingPrice: 'Da',
  experienceTotalPrice: 'Totale',
  at: 'a',
  viewPrivateSessAvailability: 'Vedi disponibilità di sessioni private',
  selectSession: 'Seleziona sessione',
  sessionsCount: '{{count}} orari — scegli un orario',
  noAvailability: 'Nessuna disponibilità',
  select: 'Seleziona',
  slotLeft: 'slot rimasto',
  slotsLeft: 'slot rimasti',
  spotsLeft: '{{count}} rimaste',
  spotsLeftAriaLabel: '{{count}} posti rimasti',
  bookExperience: 'Prenota esperienza',
  book: 'Prenota',
  learnMore: 'Scopri di più',
  maxPartySizes: 'Massimo numero di slot per gruppo',
  maxPartySize: 'Massimo numero di slot per gruppo',
  selectSessionValidation: 'Seleziona una sessione',
  selectParticipantValidation: 'Seleziona i partecipanti',
  selectDateValidation: 'Seleziona una data',
  reminders: 'Promemoria',
  seeOtherDates: 'Vedi altre date',
  location: 'Luogo',
  about: 'Su',
  allExperiences: 'Tutte le esperienze',
  soldOut: 'Esaurito',
  reviews: 'Recensioni',
  reviewSingular: 'recensione',
  reviewPlural: 'recensioni',
  dateOfExperience: "Data dell'esperienza",
  readLess: 'Leggi meno',
  readMore: 'Leggi di più',
  seeMore: 'Vedi di più',
  details: 'Dettagli',
  durationHour: 'ora',
  durationHours: 'ore',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Questo video non contiene audio',
  by: 'Da',
  chooseATime: 'Scegli un orario per {{title}}',
  amenities: 'Servizi',
  ticketSalesOpenIn: 'Vendita biglietti disponibile tra',
  ticketSalesOpen: 'Vendita biglietti aperta',
  ticketSalesCloseIn: 'Vendita biglietti chiude tra',
  ticketSalesClose: 'Vendita biglietti chiusa',
  ticketSalesClosed: 'Vendita biglietti conclusa',
  comingSoon: 'In arrivo',
  inPartnershipWith: 'In collaborazione con',
  notFoundExperienceTitle: 'Questa esperienza non è più disponibile',
  notFoundExperienceSubtitle:
    'Potrebbe essere stata rimossa o il link non è più valido.',
  deadLinkRecoverySubtitle: 'Scopri altre esperienze prenotabili',
  viewAllExperiences: 'Visualizza tutte le esperienze',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Guadagna 5 Punti Base</strong> per ogni 1 USD idoneo speso quando accedi al tuo account World of Hyatt per prenotare questa esperienza</p>',
      basePoints:
        '<p><strong>Guadagna 10 Punti Base</strong> per ogni 1 USD idoneo speso quando accedi al tuo account World of Hyatt per prenotare questa esperienza</p>',
      additionalBonusPoints:
        '<p><strong>Guadagna 4 Punti Bonus aggiuntivi</strong> per ogni 1 USD idoneo speso quando prenoti con la tua carta di credito World of Hyatt</p>',
      additionalBonusPointsTier:
        '<p><strong>Guadagna fino al 30% di Punti Bonus aggiuntivi</strong> in base al tuo livello</p>',
      payWithPoints:
        '<p><strong>Paga con Punti</strong> quando prenoti questa esperienza</p>',
    },
  },
};
